import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import PreviewModal from './PreviewModal';
import { useAuth } from '../context/AuthContext';
import clientConfigs from '../config/clientConfig';
import './HomePage.css';

const HomePage = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  const categories = [
    { id: 'institute', name: 'Design Institutes', icon: 'fa-paint-brush', count: 1 },
    { id: 'college', name: 'Colleges & Universities', icon: 'fa-university', count: 2 },
    { id: 'coaching', name: 'Coaching Centers', icon: 'fa-chalkboard-teacher', count: 1 },
    { id: 'school', name: 'Schools', icon: 'fa-school', count: 1 }
  ];

  const allTemplates = [
    {
      id: 'template7',
      name: 'Template 7 - Professional',
      category: 'Design Institute',
      description: 'Classic professional design with comprehensive information display. Perfect for educational institutes and design academies with focus on creativity.',
      features: [
        'Split-screen layout for better content organization',
        'Hero section with impressive stats display',
        'Integrated contact information sidebar',
        'Detailed form fields with validation',
        'Mobile-responsive design'
      ],
      clientId: 'iifd-surat',
      color: '#dc2626',
      suitedFor: ['Fashion Institutes', 'Design Academies', 'Creative Schools']
    },
    {
      id: 'template8',
      name: 'Template 8 - Modern Card',
      category: 'Modern Institute',
      description: 'Clean, card-based design with modern aesthetics. Ideal for institutes seeking a contemporary look with emphasis on visual hierarchy.',
      features: [
        'Card-based layout for modern appeal',
        'Stats grid with animated counters',
        'Feature highlights section',
        'Fully responsive design',
        'Clean and minimal interface'
      ],
      clientId: 'demo-institute',
      color: '#2563eb',
      suitedFor: ['Modern Institutes', 'Tech Schools', 'Innovation Centers']
    },
    {
      id: 'template9',
      name: 'Template 9 - Compact',
      category: 'Coaching Center',
      description: 'Action-oriented compact design for coaching centers. Quick and efficient enquiry process optimized for conversions.',
      features: [
        'Floating header for easy navigation',
        'Compact form for quick submissions',
        'Quick contact button for instant reach',
        'Minimal design reducing distractions',
        'Optimized for fast loading'
      ],
      clientId: 'coaching-demo',
      color: '#f5576c',
      suitedFor: ['Coaching Centers', 'Tuition Classes', 'Test Prep']
    },
    {
      id: 'template10',
      name: 'Template 10 - College',
      category: 'College',
      description: 'Professional design tailored for colleges with comprehensive information display and traditional academic aesthetics.',
      features: [
        'Hero banner with institutional branding',
        'Stats bar showcasing achievements',
        'Sidebar layout for easy navigation',
        'Professional appearance',
        'Alumni and achievement highlights'
      ],
      clientId: 'college-demo',
      color: '#3b82f6',
      suitedFor: ['Colleges', 'Polytechnics', 'Professional Institutes']
    },
    {
      id: 'template11',
      name: 'Template 11 - University',
      category: 'University',
      description: 'Prestigious formal design for universities with detailed application process and emphasis on academic excellence.',
      features: [
        'Formal header with institutional identity',
        'Breadcrumb navigation for clarity',
        'Comprehensive application forms',
        'Academic styling and typography',
        'Research and excellence showcase'
      ],
      clientId: 'university-demo',
      color: '#1a1f36',
      suitedFor: ['Universities', 'Research Institutions', 'Higher Education']
    },
    {
      id: 'template12',
      name: 'Template 12 - Modern App Style',
      category: 'Design Institute',
      description: 'Modern app-like interface with responsive design that adapts perfectly to web, tablet, and mobile devices. Features dismissible banners, bottom navigation, and smooth animations.',
      features: [
        'Sticky header with branding',
        'Dismissible welcome banner',
        'Animated stats cards',
        'Mobile-optimized bottom navigation',
        'App-like interface design',
        'Fully responsive across all devices'
      ],
      clientId: 'iifd-surat-modern',
      color: '#dc2626',
      suitedFor: ['Modern Institutes', 'Design Schools', 'Tech Academies', 'All Institution Types']
    },
    {
      id: 'template13',
      name: 'Template 13 - Clean Modern',
      category: 'Design Institute',
      description: 'Streamlined modern design focused purely on form submission. Clean interface without banner, statistics, or feature sections - perfect for institutions wanting a minimal, distraction-free enquiry experience.',
      features: [
        'Sticky header with branding',
        'Clean, focused form layout',
        'No promotional sections',
        'Contact information card',
        'Mobile-optimized bottom navigation',
        'Fully responsive design'
      ],
      clientId: 'prayaas-education',
      color: '#dc2626',
      suitedFor: ['Minimalist Institutes', 'Quick Registrations', 'All Institution Types']
    },
    {
      id: 'template14',
      name: 'Template 14 - Simple Enquiry',
      category: 'Business Institute',
      description: 'Simple and clean enquiry form with essential fields. Perfect for business schools and institutes wanting quick lead capture with program preferences.',
      features: [
        'Minimal form fields',
        'Location-based dropdowns',
        'Program selection',
        'Area of interest options',
        'Preferred mode & time selection',
        'Fully responsive design'
      ],
      clientId: 'iig-mumbai',
      color: '#2563eb',
      suitedFor: ['Business Schools', 'MBA Institutes', 'Professional Education']
    },
    {
      id: 'template15',
      name: 'Template 15 - UWILL Admission',
      category: 'Coaching Center',
      description: 'Student admission form designed for coaching classes. Clean layout with standard and course selection, optimized for quick student enrollment.',
      features: [
        'Standard/Class selection',
        'Course selection dropdown',
        'Clean admission form layout',
        'Mobile-responsive design',
        'Quick enrollment process',
        'Fully responsive design'
      ],
      clientId: 'uwill',
      color: '#072949',
      suitedFor: ['Coaching Classes', 'Tuition Centers', 'After-School Programs']
    },
    {
      id: 'template16',
      name: 'Template 16 - MDTSE Scholarship Exam',
      category: 'Coaching Center',
      description: 'Scholarship / talent search exam landing page. Marketing sections for exam dates, rewards, pattern and syllabus with a sticky registration card that pulls standards and exam categories from the online test platform.',
      features: [
        'Sticky registration card',
        'Standard driven exam category dropdown',
        'Online test API integration',
        'Exam schedule & rewards sections',
        'Class-wise syllabus tabs & FAQ',
        'Mobile sticky call / register bar'
      ],
      clientId: 'mdtse',
      color: '#9b1c1e',
      suitedFor: ['Scholarship Tests', 'Talent Search Exams', 'NEET / JEE Coaching']
    }
  ];

  // Filter templates based on authentication status and isClient flag
  const templates = allTemplates.filter(template => {
    const config = clientConfigs[template.clientId];
    // If not authenticated, show only templates with isClient: false (public templates)
    // If authenticated, show only templates with isClient: true (client templates)
    if (!isAuthenticated) {
      return config && config.isClient === false;
    } else {
      return config && config.isClient === true;
    }
  });

  const openPreview = (template) => {
    setSelectedTemplate(template);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedTemplate(null), 300);
  };

  return (
    <div className="homepage">
      <Header />

      {/* Hero Section */}
      <div className="homepage-hero" id="home">
        <div className="homepage-hero-content">
          <div className="hero-badge">
            <i className="fa fa-star"></i>
            <span>Premium Form Templates</span>
          </div>
          <h1 className="homepage-title">Proctur Educational Forms</h1>
          <p className="homepage-subtitle">
            Part of the Proctur ecosystem - Beautiful, responsive, and customizable form templates for all your educational needs.
            Streamline admissions, registrations, feedback, and more with professional designs integrated with Proctur school management software.
          </p>
          <div className="homepage-stats">
            <div className="homepage-stat">
              <span className="stat-number">7+</span>
              <span className="stat-label">Templates</span>
            </div>
            <div className="homepage-stat">
              <span className="stat-number">100%</span>
              <span className="stat-label">Responsive</span>
            </div>
            <div className="homepage-stat">
              <span className="stat-number">4</span>
              <span className="stat-label">Categories</span>
            </div>
          </div>
          <div className="hero-actions">
            <a href="#templates" className="btn-hero-primary">
              <i className="fa fa-th-large"></i>
              Browse Templates
            </a>
            <a href="#categories" className="btn-hero-secondary">
              <i className="fa fa-list"></i>
              View Categories
            </a>
          </div>
        </div>
      </div>

      {/* Categories Section */}
      <div className="homepage-categories" id="categories">
        <div className="homepage-container">
          <h2 className="section-title">Browse by Category</h2>
          <p className="section-description">
            Find the perfect template based on your institution type
          </p>

          <div className="categories-grid">
            {categories.map((category, index) => (
              <div key={index} className="category-card">
                <div className="category-icon">
                  <i className={`fa ${category.icon}`}></i>
                </div>
                <h3>{category.name}</h3>
                <p>{category.count} Template{category.count > 1 ? 's' : ''}</p>
                <a href="#templates" className="category-link">
                  Explore <i className="fa fa-arrow-right"></i>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="homepage-features" id="features">
        <div className="homepage-container">
          <h2 className="section-title">Why Choose Proctur Forms?</h2>
          <p className="section-description">
            Integrated with Proctur school management system for seamless operations
          </p>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fa fa-mobile-alt"></i>
              </div>
              <h3>Fully Responsive</h3>
              <p>Works perfectly on all devices - desktop, tablet, and mobile</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fa fa-paint-brush"></i>
              </div>
              <h3>Customizable Design</h3>
              <p>Each template can be customized to match your brand identity</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fa fa-shield-alt"></i>
              </div>
              <h3>Secure & Reliable</h3>
              <p>Built with security best practices and integrated with Proctur's reliable API</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fa fa-tachometer-alt"></i>
              </div>
              <h3>Fast Performance</h3>
              <p>Optimized for speed and excellent user experience</p>
            </div>
          </div>
        </div>
      </div>

      {/* Templates Section */}
      <div className="homepage-templates" id="templates">
        <div className="homepage-container">
          <h2 className="section-title">Available Templates</h2>
          <p className="section-description">
            Select a template that best suits your institution's style and requirements
          </p>

          <div className="templates-grid">
            {templates.map((template, index) => (
              <div key={index} className="template-card">
                <div className="template-preview" style={{ borderTopColor: template.color }}>
                  <div className="template-preview-placeholder" style={{ background: `linear-gradient(135deg, ${template.color}22 0%, ${template.color}11 100%)` }}>
                    <i className="fa fa-file-alt" style={{ color: template.color }}></i>
                    <span>{template.name}</span>
                  </div>
                </div>
                <div className="template-content">
                  <div className="template-header">
                    <h3 className="template-name">{template.name}</h3>
                    <span className="template-category" style={{ color: template.color }}>
                      {template.category}
                    </span>
                  </div>
                  <p className="template-client-name">
                    <i className="fa fa-building"></i>
                    {clientConfigs[template.clientId]?.clientName || template.clientId}
                  </p>
                  <p className="template-description">{template.description}</p>

                  <div className="template-actions">
                    <button
                      onClick={() => openPreview(template)}
                      className="btn-preview"
                      style={{ borderColor: template.color, color: template.color }}
                    >
                      <i className="fa fa-search"></i>
                      Preview
                    </button>
                    <Link
                      to={`/form/${template.clientId}`}
                      className="btn-view"
                      style={{ backgroundColor: template.color }}
                    >
                      <i className="fa fa-eye"></i>
                      View Live
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="homepage-cta" id="contact">
        <div className="homepage-container">
          <h2>Ready to Get Started?</h2>
          <p>Choose a template and integrate it with your Proctur account today!</p>
          <div className="cta-buttons">
            <a href="https://proctur.com" target="_blank" rel="noopener noreferrer" className="btn-primary">
              <i className="fa fa-globe"></i>
              Visit Proctur
            </a>
            <a href="mailto:support@proctur.com" className="btn-secondary">
              <i className="fa fa-envelope"></i>
              Contact Support
            </a>
          </div>
        </div>
      </div>

      <Footer />

      {/* Preview Modal */}
      <PreviewModal
        isOpen={isModalOpen}
        onClose={closeModal}
        template={selectedTemplate}
      />
    </div>
  );
};

export default HomePage;
